// Import service contracts and factories
import ItemChange from 'owa-service/lib/contract/ItemChange';
import PropertyUpdate from 'owa-service/lib/contract/PropertyUpdate';
import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import deleteItemField from 'owa-service/lib/factory/deleteItemField';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import itemId from 'owa-service/lib/factory/itemId';
import itemChange from 'owa-service/lib/factory/itemChange';
import RequestOptions from 'owa-service/lib/RequestOptions';
import UpdateItemResponseMessage from 'owa-service/lib/contract/UpdateItemResponseMessage';

// Import functions
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import createSetItemField from 'owa-mail-store/lib/services/utils/createSetItemField';

// Import utils
import { utcPinnedEwsTimeStamp } from 'owa-mail-list-store/lib/utils/pinningUtils';

function createRequestBody(itemIdsToUpdate: string[], shouldMarkAsPinned: boolean) {
    const itemChanges: ItemChange[] = [];
    for (const messageItemId of itemIdsToUpdate) {
        let update: PropertyUpdate;
        const propertyName = 'RenewTime';

        if (shouldMarkAsPinned) {
            // Set renew time to pin time
            update = createSetItemField(propertyName, utcPinnedEwsTimeStamp);
        } else {
            // Remove renew time property
            update = deleteItemField({
                Path: propertyUri({ FieldURI: propertyName }),
            });
        }

        const singleItemChange = itemChange({
            Updates: [update],
            ItemId: itemId({
                Id: messageItemId,
            }),
        });

        itemChanges.push(singleItemChange);
    }

    return updateItemRequest({
        ItemChanges: itemChanges,
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
    });
}

export default function markItemsAsPinnedService(
    itemIdsToUpdate: string[],
    shouldMarkAsPinned: boolean,
    options?: RequestOptions
): Promise<UpdateItemResponseMessage> {
    const requestBody = createRequestBody(itemIdsToUpdate, shouldMarkAsPinned);

    // We want to always set the pin time in UTC time, so it's invariant to user time zone
    const jsonRequestHeader = getJsonRequestHeader();
    jsonRequestHeader.TimeZoneContext.TimeZoneDefinition.Id = 'UTC';

    return updateItemOperation(
        {
            Header: jsonRequestHeader,
            Body: requestBody,
        },
        options
    ).then(response => {
        return response.Body.ResponseMessages.Items[0] as UpdateItemResponseMessage;
    });
}
